import "./App.css";
import RoutePaths from "./Routes/RoutePaths";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div className="App">
        <RoutePaths />
        <Toaster />
    </div>
  );
}

export default App;
